import { render, staticRenderFns } from "./IntegroLogoIcon.vue?vue&type=template&id=5010fb66"
import script from "./IntegroLogoIcon.vue?vue&type=script&lang=js"
export * from "./IntegroLogoIcon.vue?vue&type=script&lang=js"
import style0 from "./IntegroLogoIcon.vue?vue&type=style&index=0&id=5010fb66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports